import { Save, X } from "lucide-react";
import { formKeyNav } from "../../lib/formNav";
import ProspectSheet from "./ProspectSheet";

// Satış Pazarlama müşteri kartı formu — Excel'deki (SATIŞ PAZARLAMA.xlsx) tablo düzeninde; büyük/küçük harf dönüşümleri yazarken uygulanır
export default function ProspectForm({ form, setForm, editing, onSave, onCancel, busy }) {
  return (
    <form onSubmit={onSave} onKeyDown={formKeyNav} className="bg-white border border-amber-300 rounded-lg p-4 space-y-3" data-testid="prospect-form">
      <div className="flex items-end gap-3 flex-wrap">
        <div>
          <div className="text-lg font-bold tracking-wide">SATIŞ PAZARLAMA</div>
          <div className="text-xs font-semibold text-slate-600 mt-1">MÜŞTERİ BİLGİLERİ · {editing === "new" ? "YENİ MÜŞTERİ ADAYI" : "DÜZENLEME"}</div>
        </div>
        <span className="text-[11px] text-slate-500 ml-auto">Enter / Tab ile sonraki hücreye · ESC ile listeye dön</span>
      </div>
      <ProspectSheet form={form} setForm={setForm} edit />
      <div className="flex items-center justify-end gap-2">
        <button type="button" onClick={onCancel} data-testid="prospect-cancel" className="inline-flex items-center gap-1 px-3 py-2 rounded-md text-xs text-slate-600 hover:bg-slate-100"><X className="w-3.5 h-3.5" /> İptal <span className="text-[10px] text-slate-400">(ESC)</span></button>
        <button type="submit" disabled={busy} data-testid="prospect-save" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800 disabled:opacity-50"><Save className="w-3.5 h-3.5" /> Kaydet</button>
      </div>
    </form>
  );
}
